const NOTE_HTML_ALLOWED_STYLES = ['background-color', 'color', 'font-family', 'font-size', 'height', 'width'] as const;

export default NOTE_HTML_ALLOWED_STYLES;
